"use strict";

var _slicedToArray = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var context_1 = __importDefault(require("./context"));

var Tenant =
/*#__PURE__*/
function (_context_1$default) {
  _inherits(Tenant, _context_1$default);

  function Tenant(id) {
    var _this;

    _classCallCheck(this, Tenant);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tenant).call(this, "t", id, undefined));
    _this.type = "t";
    return _this;
  }

  _createClass(Tenant, null, [{
    key: "fromString",
    value: function fromString(context) {
      var _context$split = context.split("t/"),
          _context$split2 = _slicedToArray(_context$split, 2),
          tid = _context$split2[1];

      return new Tenant(tid);
    }
  }, {
    key: "test",
    value: function test(context) {
      var _context$split3 = context.split("t/"),
          _context$split4 = _slicedToArray(_context$split3, 2),
          tid = _context$split4[1];

      return typeof tid === "string" && tid.length > 0;
    }
  }]);

  return Tenant;
}(context_1.default);

exports.default = Tenant;